// Unsubscribes on the next tick since "next" callback gets called sync and the subscription didn't return anything yet
export var safeUnsubscribe = function (subscription) {
    setTimeout(function () { return subscription && subscription.unsubscribe(); }, 0);
};
//# sourceMappingURL=safeUnsubscribe.js.map